import styled from "styled-components"

const borderRadius = "5px"

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
`
export const ButtonGroupItem = styled.div<{
    active: boolean
}>`
    white-space: nowrap;
    cursor: pointer;
    padding: 6px 12px;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    border: 1px solid ${(props) => props.theme.buttonGroupBorderColor};
    border-bottom: none;
    background: ${(props) => (props.active ? props.theme.buttonGroupActiveBackground : props.theme.buttonGroupInactiveBackground)};
    color: ${(props) => (props.active ? props.theme.buttonGroupActiveColor : props.theme.buttonGroupInactiveColor)};
    transition: 0.1s ease;

    &:first-child {
        border-top-left-radius: ${borderRadius};
        border-top-right-radius: ${borderRadius};
    }

    &:last-child {
        border-bottom: 1px solid ${(props) => props.theme.buttonGroupBorderColor};
        border-bottom-left-radius: ${borderRadius};
        border-bottom-right-radius: ${borderRadius};
    }

    &:hover {
        background: ${(props) => props.theme.buttonGroupActiveBackground};
        color: ${(props) => props.theme.buttonGroupActiveColor};
    }
`
